import React, { useState, useEffect } from 'react';
import { userService } from '../services/api';
import { IoIosArrowForward } from 'react-icons/io';

const MatchesModal = ({ user, onClose, onUpdate }) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentMatchIndex, setCurrentMatchIndex] = useState(0);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const response = await userService.getMatches(user.id);
        setMatches(response.data);
      } catch (err) {
        console.error('Error in modal:', err);
        setError(err.message || "An error occurred while fetching matches");
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [user.id]);

  const nextMatch = () => {
    if (currentMatchIndex < matches.length - 1) {
      setCurrentMatchIndex(currentMatchIndex + 1);
    } else {
      setCurrentMatchIndex(0); // Loop back to the first match
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-11/12 max-w-md text-center max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-4">My Matches</h2>
        
        {loading && (
          <p className="text-center py-4">Finding your matches...</p>
        )}
        
        {error && (
          <p className="text-black text-center mx-auto my-5 py-2 px-4">
            {error}
          </p>
        )}
        
        {!loading && !error && (
          <div className="mb-6">
            {matches.length === 0 ? (
              <div className="py-8">
                <p className="font-bold text-gray-700 mb-4">
                  Check back later for your matches!
                </p>
                <p className="text-gray-600 text-sm">
                  We're working on finding the perfect connections for you. 
                  Keep chatting with your thought partner to improve your matching.
                </p>
              </div>
            ) : (
              <div className="relative">
                <div className="bg-white p-4 rounded-lg text-left">
                  {matches[currentMatchIndex] && (
                    <>
                      <h3 className="text-2xl font-bold text-tropical-indigo mb-1 text-left">
                        {matches[currentMatchIndex].first_name}
                      </h3>
                      <p className="text-gray-700 mb-3 text-left">
                        {matches[currentMatchIndex].connect_method}: {matches[currentMatchIndex].connect_value}
                      </p>
                      
                      {/* Match Reasons Section */}
                      <div className="mt-4">
                        <div className="mb-2">
                          <h3 className="text-xl font-bold">Match Reasoning</h3>
                        </div>
                        
                        {matches[currentMatchIndex].match_reasons && 
                         matches[currentMatchIndex].match_reasons.length > 0 ? (
                          <ul className="text-left">
                            {matches[currentMatchIndex].match_reasons.map((reason, index) => (
                              <li key={index} className="mb-2 flex items-start">
                                <span className="text-tropical-indigo mr-2">•</span>
                                {reason}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-gray-600 italic">Great compatibility based on your profiles!</p>
                        )}
                      </div>
                    </>
                  )}
                  
                  {matches.length > 1 && (
                    <button 
                      onClick={nextMatch}
                      className="absolute right-0 top-1/3 transform -translate-y-1/2 bg-lavender/10 hover:bg-lavender/20 text-tropical-indigo p-2 rounded-full"
                      aria-label="Next match"
                    >
                      <IoIosArrowForward size={24} />
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        
        <div className="flex justify-center mt-6">
          <button 
            onClick={onClose}
            className="px-8 py-2 bg-jordy-blue text-white border-none rounded hover:opacity-90 font-bold"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchesModal;